<template>
    <div class="prop-editor inline-block" :class="{'no-grid' : noGrid}" style="padding:2px;" :style="get_style()">
        <table v-if="title" class="simple-tbl" style="width:100%">
            <thead class="head">
            <tr class="row" style="height:40px;">
                <td style="text-align:center; font-size:14px;" :title="name">{{ title }}</td>
            </tr>
            </thead>
        </table>
        <table class="simple-tbl" style="width:100%">
            <tbody class="body">
            <tr class="row" v-for="(propItem, index) in propItems" :key="propItem.code">
                <td :style="getLabelStyle()" class="label" style="text-align:right; padding-right:6px;padding-top:11px; width:100px !important;">
                    <i v-if="propItem.tooltip && !viewMode  && !readOnly" class="el-icon-info" :title="propItem.tooltip"></i>
                    <label style="font-size : 13px;"><span v-show="isRequired(propItem)" style="color:red;font-weight: bold;font-size:14px;">* </span>{{ propItem.label }}</label>
                </td>
                <td>
                    <swb-pattern-input :ref="get_itemRefId(propItem)" :viewMode="viewMode" :readOnly="readOnly" :inputWidth="get_itemWidth(propItem)" :pattern="get_itemPattern(propItem)" :inputType="propItem.inputType"
                                       :asDropdown="propItem.asDropdown" :valueType="propItem.valueType" :initValue="propItem.value" :minRows="propItem.minRows" :maxRows="propItem.maxRows"
                                       :maxLength="propItem.maxLength"></swb-pattern-input>
                </td>
            </tr>
            </tbody>
        </table>
        <table v-if="showBtnBar" class="simple-tbl" style="width:100%">
            <tfoot class="foot">
            <tr class="row" style="height:60px;">
                <td colspan="2" style="text-align: center;vertical-align: middle">
                    <el-button v-if="onCancel != null" @click="do_cancel">取 消</el-button>
                    <el-button v-if="onConfirm != null" style="margin-left:60px;" @click="do_confirm">确 定</el-button>
                </td>
            </tr>
            </tfoot>
        </table>
    </div>
</template>
<script>
    import { Utils, Jqext } from '../../app.base'
    import { getDefInputTypeNameFor } from '../../app.vues'
    import SwbPatternInput from './PatternInput.vue';

    let Toast = Jqext.Toast;
    //输入类型 Text, MlText, Num, Date, Bool, Single
    //终值类型（java类型：String, Integer, Long, Float, Double, Date, Boolean
    export default {
        components: {SwbPatternInput},
        name: 'swb-prop-editor',
        desc: '通用属性项',
        //
        props: {
            name: {//名称
                type: String,
                default: null
            },
            title: {//标题
                type: String,
                default: null
            },
            noGrid: {
                type: Boolean,
                default: false
            },
            propList: {
                //{code, label, inputType, valueType, value, required, width, maxLength, minRows, maxRows, format,
                // dataList : [{label , value}], tooltip}, asDropdown, validator(code, value, label, valuesMap)
                // 注意：validator（无须处理required类校验） 只须返回校验失败的消息
                type: Array,
                default: function () {
                    return [];
                }
            },
            extra: {//自定义信息（会在 onConfirm 和 onCancel回调时回传）
                default: null
            },
            viewMode: {//是否查看模式
                type: Boolean,
                default: false
            },
            readOnly: {//是否只读模式（有别于查看模式，这里会渲染输入控件）
                type: Boolean,
                default: false
            },
            width: {//总宽度
                default: 'auto'
            },
            widthForLabel: {//左边标签宽度
                default: 100
            },
            showBtnBar: {//是否显示按钮条
                type: Boolean,
                default: false
            },
            onConfirm: {//(name, propValues, extra, this)
                type: Function,
                defaut: null
            },
            onCancel: {//(name, extra, this)
                type: Function,
                defaut: null
            }
        },
        data: function () {
            return {
                fullWidth: true,
                //
                propItems: []
            }
        },
        mounted() {
            this.init();
        },
        beforeDestroy() {
            //props
            this.propList = null;
            this.extra = null;
            this.onConfirm = null;
            this.onCancel = null;
            //data
            this.propItems = null;
        },
        watch: {
            propList(newVal, oldVal) {
                this.init();
            }
        },
        methods: {
            init() {
                //先清空列表
                this.propItems = [];
                //防止不更新
                this.$nextTick(function () {
                    let propList = this.propList || [];
                    this.propItems = propList.map(function (item) {
                        if(item.inputType == null) {//获取默认输入类型名
                            item.inputType = getDefInputTypeNameFor(item.valueType);
                        }
                        return Utils.merge({}, item);
                    });
                })
            },
            getLabelStyle() {
                let style = {};
                if(this.widthForLabel > 0) {
                    style.width = this.widthForLabel + 'px';
                }
                return style;
            },
            get_style() {
                let width = this.width;
                if(Utils.isNoB(width)) {
                    width = 'auto';
                }
                if(typeof width == 'string') {
                    if(width != 'auto' && !width.endsWith('%')) {
                        width = Utils.ParseInt(this.width) || 0;
                    }
                }
                if(typeof width == 'number') {
                    width = Math.max(width, 300);
                    width += 'px';
                }
                return {
                    width: width
                };
            },
            isRequired(propItem) {
                return !this.viewMode && !this.readOnly && propItem.required == true;
            },
            get_itemRefId(propItem) {
                return 'editor_' + propItem.code;
            },
            get_itemWidth(propItem) {
                return propItem.width || null;
            },
            get_itemPattern(propItem) {
                let coreText = '';
                let inputType = propItem.inputType || 'Text';
                if(inputType == 'Single') {
                    let dataList = propItem.dataList || [];
                    let dataItems = [];
                    let dataItem = null;
                    for(let i = 0, c = dataList.length; i < c; i++) {
                        dataItem = dataList[i];
                        dataItems[i] = dataItem.label + ':' + dataItem.value;
                        if(dataItem.disabled == true) {//
                            dataItems[i] += ':disabled';
                        }
                    }
                    coreText = dataItems.join('|');
                }
                return '{' + coreText + '}';
            },
            do_confirm() {
                if(this.onConfirm) {
                    this.onConfirm(this.name, this.getPropValues(), this.extra, this);
                }
            },
            do_cancel() {
                if(this.onCancel) {
                    this.onCancel(this.name, this.extra, this);
                }
            },
            //--------------------------------------------------------------
            setPropValues(propValues) {
                propValues = propValues || {};
                let propIndexMap = {};
                //
                let propItems = this.propItems;
                propItems.forEach(function (item, idx) {
                    propIndexMap[item.code] = idx;
                });
                //console.log(propIndexMap);
                for(let code in propValues) {
                    let index = propIndexMap[code];
                    if(index != null) {
                        let propItem = this.propItems[index];
                        propItem.value = propValues[code];
                        this.$set(this.propItems, index, Utils.merge(propItem));
                    }
                }
            },
            validate() {
                if(this.viewMode || this.readOnly) {
                    return true;
                }
                //
                let propValues = {};
                //
                let propItems = this.propItems;
                let propItem = null;
                let propFormat = null;
                let propValue = null;
                let propEditor = null;
                for(let i = 0, c = propItems.length; i < c; i++) {
                    propItem = propItems[i];
                    propEditor = this.$refs[this.get_itemRefId(propItem)][0];
                    propValue = propEditor.getValue();
                    if(propItem.valueType == 'Date' && propValue != null && propValue instanceof Date) {
                        propFormat = propItem.format || 'yyyy-MM-dd';
                        propValue = propValue.format(propFormat);
                    }
                    propValues[propItem.code] = propValue;
                    //
                    if(this.isRequired(propItem)) {
                        if(propValue == null) {
                            Toast.show('【' + propItem.label + '】未输入/选定有效值', 5000, 'warning');
                            return false;
                        }
                        let valueType = propItem.valueType;
                        if(valueType == 'String' || valueType == 'Date' || valueType == 'Character') {
                            if(Utils.isNoB(propValue)) {
                                Toast.show('【' + propItem.label + '】未输入/选定有效值', 5000, 'warning');
                                return false;
                            }
                        }
                    }
                    //自定义检验函数
                    let validator = propItem.validator;
                    if(typeof validator == 'function') {
                        let failMessage = validator(propItem.code, propValue, propItem.label, propValues);
                        if(!Utils.isNoB(failMessage)) {
                            Toast.show(failMessage, 5000, 'warning');
                            return false;
                        }
                    }
                }
                return true;
            },
            getPropValues() {
                let propValues = {};
                //
                let propItems = this.propItems;
                let propItem = null;
                let propFormat = null;
                let propValue = null;
                let propEditor = null;
                for(let i = 0, c = propItems.length; i < c; i++) {
                    propItem = propItems[i];
                    propEditor = this.$refs[this.get_itemRefId(propItem)][0];
                    propValue = propEditor.getValue();
                    if(propItem.valueType == 'Date' && propValue != null && propValue instanceof Date) {
                        propFormat = propItem.format || 'yyyy-MM-dd';
                        propValue = propValue.format(propFormat);
                    }
                    propValues[propItem.code] = propValue;
                }
                //
                return propValues;
            }
        }
    }
</script>

<style>
    .prop-editor .pattern-input .form-value {
        width: 100%;
    }

    .prop-editor .simple-tbl > .head > .row > td {
        background-color: #F5F5F5;
    }

    .prop-editor .simple-tbl > .body > tr.row > td.label {
        background-color: #EEE;
    }

    .prop-editor.no-grid .simple-tbl > .head > .row > td {
        background-color: transparent;
    }

    .prop-editor.no-grid .simple-tbl > .body > tr.row > td {
        border: 1px solid transparent;
    }

    .prop-editor.no-grid .simple-tbl > .body > tr.row > td.label {
        background-color: transparent;
    }

    .prop-editor.no-grid .simple-tbl > .body > tr.row > td.label {

    }

</style>



// WEBPACK FOOTER //
// src/compo/ctrl/PropEditor.vue